import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DialogWrapperComponent } from '../../../../../shared/components/wrappers/dialog-wrapper/dialog-wrapper.component';
import {
  DeliveryMethodSelectedAddress,
  ShippingMethodComponent
} from '../../../../../shared/components/shipping-method/shipping-method.component';
import { FormsModule } from '@angular/forms';
import { BaseDialogDirective } from '../../../../../shared/components/base/base-dialog.directive';
import { ShippingMethod } from '../../../../../core/enums/woo-commerce/shipping/shipping.enum';
import { Store } from '@ngxs/store';
import { AddDeliveryAddress } from '../../../../../shared/state/delivery/delivery.actions';
import { WooCommerceDeliveryAddress } from '../../../../../core/interfaces/woo-commerce/api/woo-commerce-api.interface';

@Component({
  selector: 'app-restaurant-delivery-method-dialog',
  templateUrl: './restaurant-delivery-method-dialog.component.html',
  imports: [DialogWrapperComponent, FormsModule, ShippingMethodComponent],
  styleUrl: './restaurant-delivery-method-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RestaurantDeliveryMethodDialogComponent extends BaseDialogDirective<DeliveryMethodSelectedAddress> {
  constructor(private store: Store) {
    super();
  }

  onDeliveryMethodChange(deliveryMethod: DeliveryMethodSelectedAddress) {
    if (deliveryMethod.method === ShippingMethod.Delivery) {
      this.store.dispatch(
        new AddDeliveryAddress(
          deliveryMethod.address as WooCommerceDeliveryAddress
        )
      );
    }

    this.dialogRef.close(deliveryMethod);
  }
}
